import { createAction } from '@wix/communities-blog-client-common';

export const ADD_CATEGORY = 'category/ADD';
export const addCategory = createAction(
  ADD_CATEGORY,
  (payload, meta) => payload,
  (_payload, meta) => meta,
);
